<template>
  <v-combobox
    v-model="scenarioElements"
    ref="combobox"
    :items="availableElements"
    :item-text="showLogicalLanguage ? 'prolog' : 'name'"
    item-value="id"
    :label="$t(label)"
    multiple
    counter="200"
    maxLength="200"
    allow-overflow
    outlined
    :search-input.sync="search"
    @change="onChange"
    :clearable="true"
    @click:clear="onChange(scenarioElements)"
    :hide-details="true"
    :disabled="disabled"
    :auto-select-first="!enableElementCreation"
    :menu-props="{ closeOnClick: true, closeOnContentClick: true }"
  >
    <template v-slot:selection="data">
      <v-progress-circular
        v-if="isString(data.item) && data.item.trim().length !== 0"
        color="grey lighten-2"
        indeterminate
      />
      <element-chip
        v-else-if="!isString(data.item)"
        :element="data.item"
      />
    </template>

    <template v-slot:item="data">
        <v-list-item-icon>
          <v-icon v-if="data.attrs.inputValue">mdi-checkbox-marked</v-icon>
          <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <element-chip
            :element="data.item"
          />
        </v-list-item-content>
    </template>

    <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('scenario.noResultsMatching') }} "<strong>{{ search }}</strong>".
              <span v-if="enableElementCreation">{{ $t('scenario.press') }} <kbd>{{ $t('scenario.enter') }}</kbd> {{ $t('scenario.toCreateNewOne') }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
  </v-combobox>
</template>

<script>
import ElementChip from "@/components/global/ElementChip"
import elementService from "@/services/elements.js"
import naturalOrLogicalLanguageMixin from '@/mixins/natural-or-logical-language-mixin.js'

export default {
  name: "InputScenario",

  components: { ElementChip },

  mixins: [ naturalOrLogicalLanguageMixin ],

  data() {
    return {
      projectId: this.$route.params.id,
      search: null,
    };
  },

  props: {
    availableElements: {
      type: Array,
      required: true,
    },
    elements: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: 'scenario.elements'
    },
    enableElementCreation: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    scenarioElements: {
      get () {
          return this.elements;
      },
      set (value) {
          this.$emit('update:elements', value);
      }
    },
  },

  watch: {
    scenarioElements(val, prev) {
      // console.log('scenarioElements', val)
      if (val.length === prev.length) {
        return
      }
      if(this.enableElementCreation) {
        const newElements = val.filter(v => this.isString(v))
        for(const elt of newElements) {
          // search if the element exists
          const foundElement = this.availableElements.findIndex(element => this.showLogicalLanguage ? element.prolog === elt : element.name === elt)
          // console.log('scenarioElements foundElement', foundElement, this.availableElements)
          if(foundElement >= 0) {
            // console.log('scenarioElements foundElement, replace with exact match at ', foundElement)
            const index = this.scenarioElements.findIndex(elementString => elt === elementString)
            this.scenarioElements.splice(index, 1, this.availableElements[foundElement])
            this.availableElements.splice(0, 0, this.availableElements[foundElement])
          }
          else {
            // console.log('scenarioElements NOT foundElement, try to create, index is ', foundElement)
            this.createElement(elt)
          }
        }
      }
      else {
        this.scenarioElements = val.filter(v => !this.isString(v))
      }
    },
  },

  methods: {
    createElement(elementString) {
      elementService.createElement(this.projectId, this.convertStringToElement(elementString))
      .then(response => {
          console.log('createElement success', elementString)
          const elementCreated = response.data
          const index = this.scenarioElements.findIndex(elt => elt === elementString)
          this.scenarioElements.splice(index, 1, elementCreated)
          this.availableElements.splice(0, 0, elementCreated)
          this.$refs.combobox.blur()
        })
        .catch((err) => {
          console.log('createElement failed', elementString)
          const index = this.scenarioElements.findIndex(elt => elt === elementString)
          this.scenarioElements.splice(index, 1)
          this.$emit("raison-event", { type:"error", messages: [err] });
        })
        .finally(() => {
        });
    },

    onChange(scenario) {
      console.log('onChange', scenario)
      this.search = null
      this.$emit('scenario-updated', scenario)
    },

    isString(value) {
      return typeof value === "string" && value.trim().length > 0
    },

    convertStringToElement(elementValue) {
      if (this.isString(elementValue)) {
        const result = {
          name: this.showLogicalLanguage ? "" : elementValue,
          prolog: this.showLogicalLanguage ? elementValue : "",
          isParameter: true
        };
        console.log('convertStringToElement', elementValue, result)
        return result;
      }
      return elementValue;
    },
  },

};
</script>
<style scoped>
.v-list-item__content > * {
  /* justify-content: center!important; */
  line-height: 1.5;
}
</style>